// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--ulq5F","container--open":"a2c79c7e7d--container--open--hu06i","more":"a2c79c7e7d--more--p8fqM","text":"a2c79c7e7d--text--Gndko"};